var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-container"},[_vm._v(" 测试接口界面 "),_c('div',[_c('el-pagination',{attrs:{"current-page":1,"page-sizes":[10, 20, 50, 100],"page-size":11,"layout":"total, prev, pager, next, jumper, ->, sizes","total":5000}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }